import React, { useRef, useEffect, useState } from 'react'
import { Modal, message, Col, Row, ConfigProvider, Button} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import '../course.module.css'
import zhCN from 'antd/lib/locale/zh_CN'
import { checkUserLogin } from '../../common/user-center/user-info'
import courseStudentCasesStyles from './course-main-student-cases.module.less'
import Cookies from 'js-cookie'
import shiyanEmpty from '../../../static/image/empty/queshengye-shiyan.png'
import Draggable from 'react-draggable'


import slidesStyles from '../slides/course-main-teacher-slides.module.less'
import caseStyles from '../../case/case.module.less'
import defaultCaseCover from '../../../static/image/case/default_case_cover.png'
import * as constants from '../../../constants/constants'

import Icon from '@ant-design/icons'
import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
import  {ReactComponent as coderunSvg }   from '../../../static/image/course/coderun.svg'
const coderunIcon = (props:any) => (<Icon component={coderunSvg} {...props} />)

export interface Props {
  course_id: any
}
/** 教师课程实验列表页面 */
export const CourseMainStudentCases: React.FC<Props> = (props) => {
  const { course_id } = props
  const [disabled, setDisabled] = useState(true)
  const [isInitCaseModal, setIsInitCaseModal] = useState(false) // 初始化实验
  const [casesList, setCasesList] = useState([] as any[]) //课程的实验
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 }) // Modal框移动
  const [selectedCaseName, setSelectedCaseName] = useState('')
  const [selectedCaseId, setSelectedCaseId] = useState(0)

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const routeToCaseRun = (record: any, case_id: number, course_id?: any) => {
    window.open(`/case-run?case_id=${case_id}`)
  }

  const onRunCaseBtnClick = (record: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    }
    let params = {
      case_id: record.id,
      course_id: course_id,
    }
    sendHttpPostRequest(
      'course/api/user_get_or_fork_course_case_by_id',
      params,
      (res) => {
        if (res.code == 0) {
          routeToCaseRun(record, res.case_info.case_id, course_id)

          queryCases()
        } else {
          message.error(res.message)
        }
      }
    )
  }

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef.current!.getBoundingClientRect()

    setBounds({
      left: -targetRect?.left + uiData?.x,
      right: clientWidth - (targetRect?.right - uiData?.x),
      top: -targetRect?.top + uiData?.y,
      bottom: clientHeight - (targetRect?.bottom - uiData?.y),
    })
  }

  const onPreviewCaseBtnClick = (caseId: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      window.open(
        `/course-case-detail?case_id=${caseId}&course_id=${course_id}`
      )
    }
  }



  useEffect(() => {
    queryCases()
  }, [])
  const url = 'course/api/user_reset_course_case'
  const onInitCaseOk = () => {
    //  这里写  初始化请求代码
    sendHttpPostRequest(
      url,
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        case_id: selectedCaseId,
      },
      (res) => {
        message.destroy()
        if (res.is_ok) {
          // 请求成功

          message.success('初始化成功')
          setTimeout(function () {
            queryCases()
          }, 1000)
        } else {
          message.error('初始化失败')
        }
      }
    )

    //请求结束  关闭模态框
    setIsInitCaseModal(false)
  }
  const onInitCaseCancel = () => {
    //取消  隐藏模态框
    setIsInitCaseModal(false)
  }

  const queryCases = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_info',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
      },
      (response: any) => {
        if (response.is_ok) {
          setCasesList(response.query_info.case_list)
        }
      }
    )
  }

  return (
    <div >
      <Row gutter={[24, 24]} justify="start"  align="middle" wrap={true}>
        {casesList?.map((caseInterface) => {
          return (
            <Col span={6} key={caseInterface.case_id}>
              <div 
                className={caseStyles.caseCard} style={{height:'100%', width:'100%',border: '1px solid #e5e7eb'}}
              >

                <div className={caseStyles.caseCardCoverDiv} style={{height:100}}>

                    {caseInterface.cover == '' ? (
                      <img
                        alt=""
                        src={defaultCaseCover}
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    ) : (
                      <img
                        alt=""
                        src={
                          caseInterface.cover?.startsWith('http')
                            ? caseInterface.cover
                            : constants.BACKEND_URL +
                              caseInterface.cover
                        }
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    )}
                </div>
                
                <div className={caseStyles.caseCardContentDiv} style={{height:'100%'}}>

                  <div
                      style={{
                        textAlign: 'left',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        marginBottom:0
                      }}
                      title={caseInterface.name}

                      className={caseStyles.caseTitle}
                    >
                      {caseInterface.name}
                    </div>

                       
                </div>


                <Row wrap={false} align="middle" className={slidesStyles.actionDiv} style={{borderRadius:'0 0 12px 12px'}}>
                    <Col span={12} style={{textAlign:'left'}}>
                      <div>

                        </div>
                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>
                          <span title="查看" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onPreviewCaseBtnClick.bind(this, caseInterface)}
                           
                          ><Icon component={eyeIcon}/></span>  

                          <span title="运行" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onRunCaseBtnClick.bind(this, caseInterface)}
                           
                          ><Icon component={coderunIcon}/></span>  
 
                      </div>
                    </Col>
                  </Row>
            </div>
            </Col>
          )
        })}
      </Row>

        {casesList.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={shiyanEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              您还没有添加实验哟~
            </div>
          </div>
        )}


      {/* 初始化实验 */}
      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              <span className={courseStudentCasesStyles.classtitle}>提示</span>
            </div>
          }
          centered
          className={courseStudentCasesStyles.initmodal}
          open={isInitCaseModal}
          onOk={onInitCaseOk}
          okText={'确认'}
          onCancel={onInitCaseCancel}
          bodyStyle={{ height: '112px' }}
          destroyOnClose={true}
          width={285}
          footer={[
            <Button key="return" type="default" onClick={onInitCaseCancel}>
              取消
            </Button>,
            <Button key="submit" type="primary" onClick={onInitCaseOk}>
              确认
            </Button>,
          ]}
          modalRender={(modal) => (
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>
          )}
        >
          <Row
            justify="center"
            align="middle"
            gutter={[32, 32]}
            className={courseStudentCasesStyles.textarea}
          >
            <Col span={24}>
              <div style={{ textAlign: 'center' }}>
                您确认初始化实验<span> {selectedCaseName} </span>吗?{' '}
                <span style={{ color: '#ff0000' }}>
                  初始化后已编辑内容将清空
                </span>
                。
              </div>
            </Col>
          </Row>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default CourseMainStudentCases
